import { render } from "./Kasir_c.vue?vue&type=template&id=208e8b40&scoped=true"
import script from "./Kasir_c.vue?vue&type=script&lang=js"
export * from "./Kasir_c.vue?vue&type=script&lang=js"

import "./Kasir_c.vue?vue&type=style&index=0&id=208e8b40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-208e8b40"

export default script